var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2MakeUpRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zm-20-6.56V48h10v10.44A2.59 2.59 0 0156.39 61h-4.78A2.59 2.59 0 0149 58.44zM58 45h-8v-4h8v4zm-2-7h-4v-6.12l4-2.18V38zm-38.6-1.9A14.62 14.62 0 0030 50.57V57h-5v4h14v-4h-5v-6.43A14.6 14.6 0 1017.4 36.1zm25.2 0A10.6 10.6 0 1132 25.5a10.61 10.61 0 0110.6 10.6zm-11.19-2.53l5 1.33-5 1.34-1.33 5-1.33-5-5-1.34 5-1.33 1.33-5 1.33 5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Make_up_room.9413facd.svg";
export { SvgE2MakeUpRoom as ReactComponent };